<template>
    <div id="Home" :style="{minHeight:screenHeight+'px'}">
        <Nav/>
        <div :style="{width:'100%',height:screenHeight+'px',position:'absolute',top:0,left:0}">
            <div class="swiper-container main_swiper" :style="{width:'100%',height:'100%'}">
                <div class="swiper-wrapper" :style="{width:'100%',height:'100%'}">
                    <div class="swiper-slide slide1" :style="{width:'100%',height:'100%'}">
                        <div>
                            <h3>10年深耕医药行业</h3>
                            <h4 class="hasspace">共建医药未来商学院</h4>
                            <div :style="{width:'100%',height:'70%'}" class="slide1_ban">
                                <h5>致力为医药行业提供最优质最高效的知识，同最强行业大脑一起进步</h5>
                                <img src="../../static/images/slide1_ban.png" alt="商学院"
                                     class="img-responsive center-block">
                            </div>
                        </div>

                    </div>
                    <div class="swiper-slide slide2" :style="{width:'100%',height:'100%'}">
                        <div>
                            <h3>微解药</h3>
                            <h4>新知识，新方法，新E药经理人全在"微解药"</h4>
                            <div :style="{width:'100%',height:'70%'}" class="slide2_ban">
                                <img src="../../static/images/slide2_ban.png" alt="E药经理人"
                                     class="img-responsive center-block">
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide slide3" :style="{width:'100%',height:'100%'}">
                        <div>
                            <h3>产品介绍</h3>
                            <h4>五大王牌 放心之选</h4>
                            <div :style="{width:'100%',height:'70%'}" class="slide3_ban">
                                <div :style="{width:'100%',height:'90%'}">
                                    <img src="../../static/images/slide3_pro1.jpg" alt="" class="moveTop">
                                    <img src="../../static/images/slide3_pro2.jpg" alt="" class="moveBottom">
                                    <img src="../../static/images/slide3_pro3.jpg" alt="" class="moveMiddle">
                                    <img src="../../static/images/slide3_pro4.jpg" alt="" class="moveBottom">
                                    <img src="../../static/images/slide3_pro5.jpg" alt="" class="moveTop">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide slide4" :style="{width:'100%',height:'100%'}">
                        <div class="slide4_ban">
                            <div class="tipLeft">
                                <h3>大咖在微解药</h3>
                                <h4>今天听什么由你来定</h4>
                            </div>
                            <div class="polygon">
                                <div class="polygon_child">
                                    <div class="round_big round_big1"></div>
                                    <div class="round_small round_small1"></div>
                                    <div class="round_big round_big2">
                                        <img src="../../static/images/guoyunpei.png" alt="guoyunpei">
                                    </div>
                                    <div class="round_big round_big3"></div>
                                    <div class="round_middle round_middle1"></div>
                                    <div class="round_middle round_middle2"></div>
                                    <div class="round_big round_big4">
                                        <img src="../../static/images/tanyong.png" alt="tanyong">
                                    </div>
                                    <div class="round_middle round_middle3">
                                        <img src="../../static/images/group_10.png" alt="group_10">
                                    </div>
                                    <div class="round_middle round_middle4">
                                        <img src="../../static/images/group_11.png" alt="group_10">
                                    </div>
                                    <div class="round_middle round_middle5"></div>
                                    <div class="round_middle round_middle6"></div>
                                    <div class="round_small round_small2"></div>
                                    <div class="round_small round_small3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide slide5" :style="{width:'100%',height:'100%'}">
                        <div>
                            <h3>商学院</h3>
                            <h4>持续推动中国医药企业进入全球医药行业三甲之列</h4>
                            <h4>全力打造医药行业人才大学</h4>
                            <div :style="{width:'100%',height:'70%'}" class="slide5_ban">
                                <div class="tip1">
                                    <span>走进华为线下活动-医药行业唯一合作伙伴</span>
                                </div>
                                <div class="tip2">
                                    <span>共建一所未来医药大学</span>
                                </div>
                                <div class="tip3">
                                    <span>提供医药行业人才核心竞争力</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide slide6" :style="{width:'100%',height:'100%'}">
                        <div>
                            <h3>免费专区</h3>
                            <h4>最新行业咨询天天独家解读，名人座谈读懂行业政策、市场、营销。</h4>
                            <div :style="{width:'100%',height:'60%'}" class="slide6_ban">
                                <img src="../../static/images/slide6_ban.png" alt="座谈"
                                     class="img-responsive center-block">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination main_pagination"></div>

            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import Nav from '@/components/common/nav'

    export default {
        name: 'Home',
        data() {
            return {
            }
        },
        computed: {
            screenHeight() {
                return window.innerHeight || document.documentElement.clientHeight
            }
        },
        created(){
          console.log(screen.width)
        },
        components: {
            Nav,
        },
        methods: {
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop <= 0) {

                } else {

                }

            },

        },
        mounted() {

            var mySwiper = new Swiper('.main_swiper', {
                freeMode: false,
                //direction: 'horizontal',
                direction: 'vertical',
                mousewheel : true,
                autoplay: {
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    delay: 1000000
                },
                loop: true,
                // 如果需要分页器
                pagination: {
                    el: '.main_pagination',
                    clickable: true,
                    // bulletActiveClass: 'my-bullet-active',
                },

            })

            window.addEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style scoped lang="scss">
    .slide1 {
        background-image: url('../../static/images/slide1_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;
    }

    .slide2 {
        background-image: url('../../static/images/slide2_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide3 {
        background-image: url('../../static/images/slide3_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide4 {
        background-image: url('../../static/images/slide4_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide5 {
        background-image: url('../../static/images/slide5_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide6 {
        background-image: url('../../static/images/slide6_bg.jpg');
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;
    }
    @media screen and (min-width: 1679px) {
        #Home {
            .swiper-slide {
                text-align: center;
                position: relative;
                h3 {
                    font-size: 100px;
                    line-height: 1.5 !important;
                }
                h4 {
                    font-size: 34px;
                    color: #666;
                    line-height: 1.5 !important;
                }
                h5 {
                    font-size: 24px;
                    color: #ccc;
                    /*line-height: !important;*/
                }
                .hasspace{
                    letter-spacing:15px;
                }
                > div {
                    left: 50%;
                    transform: translate(-50%);
                    position: absolute;
                    bottom: 0;
                    overflow: hidden;
                    width: 80%;
                    height: 82%;
                    > div {
                        left: 50%;
                        transform: translate(-50%);
                        position: absolute;
                        bottom: 0;
                        > img {
                            width: 80%;
                            height: 100%;
                        }
                    }
                }
                .slide3_ban {
                    > div {
                        display: flex;
                        justify-content: space-between;
                        align-items: baseline;
                        .moveMiddle {
                            transform: translateY(60px);
                        }
                        .moveBottom {
                            transform: translateY(90px);
                        }
                    }
                }
                .slide4_ban {
                    > .tipLeft {
                        position: absolute;
                        left: 5%;
                        top: 50%;
                        transform: translate(0, -50%);
                    }
                    > .polygon {
                        width: 620px;
                        height: 615px;
                        background: url('../../static/images/polygon_bg.gif') no-repeat center center;
                        background-size: cover;
                        left: 100% !important;
                        transform: translate(-100%) !important;
                        top: 10%;
                        .polygon_child {
                            width: 550px;
                            height: 615px;
                            background: url('../../static/images/polygon.jpg') no-repeat center center;
                            background-size: cover;
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            > div {
                                position: absolute;
                            }
                            .round_big {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;

                            }
                            .round_small {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_middle {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_big1 {
                                left: 50%;
                                transform: translate(-50%);
                            }
                            .round_small1 {
                                top: 21%;
                                left: -2%;
                            }
                            .round_big2 {
                                top: 19%;
                                left: 25%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_big3 {
                                top: 19%;
                                left: 60%;

                            }
                            .round_middle1 {
                                top: 20%;
                                left: 96%;
                            }
                            .round_middle2 {
                                top: 44%;
                                left: 10%;

                            }
                            .round_big4 {
                                top: 43%;
                                left: 44%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle3 {
                                top: 45%;
                                left: 80%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle4 {
                                top: 68%;
                                left: -5%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle5 {
                                top: 68%;
                                left: 27%;
                            }
                            .round_middle6 {
                                top: 68%;
                                left: 63%;
                            }
                            .round_small2 {
                                top: 69%;
                                left: 94%;
                            }
                            .round_small3 {
                                top: 94%;
                                left: 50%;
                                transform: translate(-50%);
                            }
                        }

                    }
                    h3, h4 {
                        text-align: left;
                    }
                }
                .slide5_ban {
                    background: url("../../static/images/slide5_phone.png") no-repeat center bottom;
                    background-size: 60%;
                    > .tip1 {
                        width: 580px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip1.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 25%;
                        margin-top: 5%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }

                    }
                    > .tip2 {
                        width: 380px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip2.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 10%;
                        margin-top: 5%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                    > .tip3 {
                        width: 460px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip3.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 50%;
                        margin-top: -3%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (min-width: 1440px) and (max-width: 1678px){
        #Home {
            .swiper-slide {
                text-align: center;
                position: relative;
                h3 {
                    font-size: 80px;
                    line-height: 1.5 !important;
                }
                h4 {
                    font-size: 34px;
                    color: #666;
                    line-height: 1.5 !important;
                }
                h5 {
                    font-size: 24px;
                    color: #ccc;
                    /*line-height: !important;*/
                }
                .hasspace{
                    letter-spacing:15px;
                }
                > div {
                    left: 50%;
                    transform: translate(-50%);
                    position: absolute;
                    bottom: 0;
                    overflow: hidden;
                    width: 80%;
                    height: 82%;
                    > div {
                        left: 50%;
                        transform: translate(-50%);
                        position: absolute;
                        bottom: 0;
                        > img {
                            width: 80%;
                            height: 100%;
                        }
                    }
                }
                .slide3_ban {
                    > div {
                        display: flex;
                        justify-content: space-between;
                        align-items: baseline;
                        .moveMiddle {
                            transform: translateY(60px);
                        }
                        .moveBottom {
                            transform: translateY(90px);
                        }
                    }
                }
                .slide4_ban {
                    > .tipLeft {
                        position: absolute;
                        left: 5%;
                        top: 45%;
                        transform: translate(0, -50%);
                    }
                    > .polygon {
                        width: 620px;
                        height: 615px;
                        background: url('../../static/images/polygon_bg.gif') no-repeat center center;
                        background-size: cover;
                        left: 100% !important;
                        transform: translate(-100%) !important;
                        top: 0;
                        .polygon_child {
                            width: 550px;
                            height: 615px;
                            background: url('../../static/images/polygon.jpg') no-repeat center center;
                            background-size: cover;
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            > div {
                                position: absolute;
                            }
                            .round_big {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;

                            }
                            .round_small {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_middle {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_big1 {
                                left: 50%;
                                transform: translate(-50%);
                            }
                            .round_small1 {
                                top: 21%;
                                left: -2%;
                            }
                            .round_big2 {
                                top: 19%;
                                left: 25%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_big3 {
                                top: 19%;
                                left: 60%;

                            }
                            .round_middle1 {
                                top: 20%;
                                left: 96%;
                            }
                            .round_middle2 {
                                top: 44%;
                                left: 10%;

                            }
                            .round_big4 {
                                top: 43%;
                                left: 44%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle3 {
                                top: 45%;
                                left: 80%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle4 {
                                top: 68%;
                                left: -5%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle5 {
                                top: 68%;
                                left: 27%;
                            }
                            .round_middle6 {
                                top: 68%;
                                left: 63%;
                            }
                            .round_small2 {
                                top: 69%;
                                left: 94%;
                            }
                            .round_small3 {
                                top: 94%;
                                left: 50%;
                                transform: translate(-50%);
                            }
                        }

                    }
                    h3, h4 {
                        text-align: left;
                    }
                }
                .slide5_ban {
                    background: url("../../static/images/slide5_phone.png") no-repeat center bottom;
                    background-size: 60%;
                    > .tip1 {
                        width: 580px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip1.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 25%;
                        margin-top: 5%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }

                    }
                    > .tip2 {
                        width: 380px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip2.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 10%;
                        margin-top: 1%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                    > .tip3 {
                        width: 460px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip3.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 50%;
                        margin-top: -3%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (min-width: 1201px) and (max-width: 1439px){
        #Home {
            .swiper-slide {
                text-align: center;
                position: relative;
                h3 {
                    font-size: 60px;
                    line-height: 1.5 !important;
                }
                h4 {
                    font-size: 28px;
                    color: #666;
                    line-height: 1.5 !important;
                }
                h5 {
                    font-size: 18px;
                    color: #ccc;
                    /*line-height: !important;*/
                }
                .hasspace{
                    letter-spacing:15px;
                }
                > div {
                    left: 50%;
                    transform: translate(-50%);
                    position: absolute;
                    bottom: 0;
                    overflow: hidden;
                    width: 80%;
                    height: 82%;
                    > div {
                        left: 50%;
                        transform: translate(-50%);
                        position: absolute;
                        bottom: 0;
                        > img {
                            width: 80%;
                            height: 100%;
                        }
                    }
                }

                .slide3_ban {
                    > div {

                        display: flex;
                        justify-content: space-between;
                        align-items: baseline;
                        img{
                            height: 100%;
                        }
                        .moveMiddle {
                            transform: translateY(30px);
                        }
                        .moveBottom {
                            transform: translateY(90px);
                        }
                    }
                }
                .slide4_ban {
                    > .tipLeft {
                        position: absolute;
                        left: 5%;
                        top: 45%;
                        transform: translate(0, -50%);
                    }
                    > .polygon {
                        width: 570px;
                        height: 580px;
                        background: url('../../static/images/polygon_bg.gif') no-repeat center center;
                        background-size: cover;
                        left: 100% !important;
                        transform: translate(-100%) !important;
                        top: 0;
                        .polygon_child {
                            width: 500px;
                            height: 570px;
                            background: url('../../static/images/polygon.jpg') no-repeat center center;
                            background-size: cover;
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            > div {
                                position: absolute;
                            }
                            .round_big {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;

                            }
                            .round_small {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_middle {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_big1 {
                                left: 50%;
                                transform: translate(-50%);
                            }
                            .round_small1 {
                                top: 21%;
                                left: -2%;
                            }
                            .round_big2 {
                                top: 19%;
                                left: 25%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_big3 {
                                top: 19%;
                                left: 60%;

                            }
                            .round_middle1 {
                                top: 20%;
                                left: 96%;
                            }
                            .round_middle2 {
                                top: 44%;
                                left: 10%;

                            }
                            .round_big4 {
                                top: 43%;
                                left: 44%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle3 {
                                top: 45%;
                                left: 80%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle4 {
                                top: 68%;
                                left: -5%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle5 {
                                top: 68%;
                                left: 27%;
                            }
                            .round_middle6 {
                                top: 68%;
                                left: 63%;
                            }
                            .round_small2 {
                                top: 69%;
                                left: 94%;
                            }
                            .round_small3 {
                                top: 94%;
                                left: 50%;
                                transform: translate(-50%);
                            }
                        }

                    }
                    h3, h4 {
                        text-align: left;
                    }
                }
                .slide5_ban {
                    background: url("../../static/images/slide5_phone.png") no-repeat center bottom;
                    background-size: 60%;
                    > .tip1 {
                        width: 580px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip1.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 25%;
                        margin-top: 2%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }

                    }
                    > .tip2 {
                        width: 380px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip2.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 10%;
                        margin-top: 3%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                    > .tip3 {
                        width: 460px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip3.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 50%;
                        margin-top: -3%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                }
            }
            .slide3>div{
                left: 50%;
                -webkit-transform: translate(-50%);
                transform: translate(-50%);
                position: absolute;
                bottom: 40px;
                overflow: hidden;
                width: 80%;
                height: 82%;
            }
        }

    }
    @media screen and (max-width: 1200px) {
        #Home {
            .swiper-slide {
                text-align: center;
                position: relative;
                h3 {
                    font-size: 74px;
                    line-height: 1.5 !important;
                }
                h4 {
                    font-size: 36px;
                    color: #666;
                    line-height: 1.5 !important;
                }
                h5 {
                    font-size: 24px;
                    color: #ccc;
                    /*line-height: !important;*/
                }
                > div {
                    left: 50%;
                    transform: translate(-50%);
                    position: absolute;
                    bottom: 0;
                    overflow: hidden;
                    > div {
                        left: 50%;
                        transform: translate(-50%);
                        position: absolute;
                        bottom: 0;
                        > img {
                            width: 80%;
                            height: 100%;
                        }
                    }
                }
                .slide3_ban {
                    > div {
                        display: flex;
                        justify-content: space-between;
                        align-items: baseline;
                        .moveMiddle {
                            transform: translateY(60px);
                        }
                        .moveBottom {
                            transform: translateY(90px);
                        }
                    }
                }
                .slide4_ban {
                    > .tipLeft {
                        position: absolute;
                        left: 5%;
                        top: 60%;
                        transform: translate(0, -50%);
                    }
                    > .polygon {
                        width: 580px;
                        height: 615px;
                        background: url('../../static/images/polygon_bg.gif') no-repeat center center;
                        background-size: cover;
                        left: 100% !important;
                        transform: translate(-100%) !important;
                        top: 20%;
                        .polygon_child {
                            width: 550px;
                            height: 615px;
                            background: url('../../static/images/polygon.jpg') no-repeat center center;
                            background-size: cover;
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            > div {
                                position: absolute;
                            }
                            .round_big {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;

                            }
                            .round_small {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_middle {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                background: #fff;
                                box-shadow: 0 0 5px #ccc;
                            }
                            .round_big1 {
                                left: 50%;
                                transform: translate(-50%);
                            }
                            .round_small1 {
                                top: 21%;
                                left: -2%;
                            }
                            .round_big2 {
                                top: 19%;
                                left: 25%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_big3 {
                                top: 19%;
                                left: 60%;

                            }
                            .round_middle1 {
                                top: 20%;
                                left: 96%;
                            }
                            .round_middle2 {
                                top: 44%;
                                left: 10%;

                            }
                            .round_big4 {
                                top: 43%;
                                left: 44%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle3 {
                                top: 45%;
                                left: 80%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle4 {
                                top: 68%;
                                left: -5%;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .round_middle5 {
                                top: 68%;
                                left: 27%;
                            }
                            .round_middle6 {
                                top: 68%;
                                left: 63%;
                            }
                            .round_small2 {
                                top: 69%;
                                left: 94%;
                            }
                            .round_small3 {
                                top: 94%;
                                left: 50%;
                                transform: translate(-50%);
                            }
                        }

                    }
                    h3, h4 {
                        text-align: left;
                    }
                }
                .slide5_ban {
                    background: url("../../static/images/slide5_phone.png") no-repeat center bottom;
                    background-size: 60%;
                    > .tip1 {
                        width: 580px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip1.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 25%;
                        margin-top: 5%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }

                    }
                    > .tip2 {
                        width: 380px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip2.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 10%;
                        margin-top: 5%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                    > .tip3 {
                        width: 460px;
                        height: 80px;
                        background: url('../../static/images/slide5_tip3.jpg') no-repeat center center;
                        background-size: cover;
                        margin-left: 50%;
                        margin-top: -3%;
                        span {
                            color: #fff;
                            font-size: 22px;
                            height: 80px;
                            line-height: 80px;
                        }
                    }
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/Home.vue